export interface WhiteLabelConfig {
    context: string
    lang: string
}

export const defaultWhiteLabelConfig: WhiteLabelConfig = {
    context: "staffline",
    lang: "EN"
}